
export default {
  name: 'PageTerms',

  head() {
    return {
      title: 'Privacy and Cookie Policy',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'This Privacy &amp; Cookie Policy is here to help you understand how we use your data and how we protect it and shows what cookies we are using.'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Privacy and Cookie Policy',
        image: require('~/assets/images/backgrounds/voucher-hero.jpg'),
        alt: '3 dogs in a paddock'
      }
    }
  }
}
